module.exports = __webpack_public_path__ + "static/img/zf_img_function02.2508e4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/zf_img_function02.png
// module id = /B/d
// module chunks = 1